export default "__VITE_ASSET__P0K6vuNX__"